import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  autocomplete: {
    height: "70px",
  },
}))

export default useStyles
